"use client";

// ================================================================
// AgentC Client Library - Core Components Only
// ================================================================

// Main Chatbot Components (Recommended for most users)
export { FloatingChatButton } from "./components/chatbot/customer/floating-chat-button";
export { MobileFullscreenChat } from "./components/chatbot/customer/mobile-fullscreen-chat";

// Types (Essential for TypeScript users)
export type {
  Message,
  AgentConfig,
} from "./components/chatbot/customer/floating-chat-button";

// Admin Components (Working)
export { RAGAdminIntegrated } from "./lib/chatbot/admin/components/rag-admin-integrated";

// Individual Admin Components
export {
  RAGManager,
  DocumentUploader,
  RSSManager,
  QALearningManager,
  AgentConfigManager,
} from "./lib/chatbot/admin/components";

// Utils (Essential)
export { cn } from "./utils/cn";
